<template>
  <div class="reset-card">
    <div v-if="!state.tokenValid && !state.checked" class="reset-card__validating">
      Validando token...
    </div>

    <template v-else-if="state.tokenValid && state.checked">
      <h2 class="reset-card__title">Nova senha</h2>
      <p class="reset-card__sub">Informe sua nova senha para redefinir seu acesso.</p>

      <form @submit.prevent="handleChangePassword">
        <InputField
          v-model="state.password.value"
          label="Nova senha"
          type="password"
          placeholder="••••••••••"
          :error="state.password.errorMessage"
        />
        <InputField
          v-model="state.confirmPassword.value"
          label="Confirmar senha"
          type="password"
          placeholder="••••••••••"
          :error="state.confirmPassword.errorMessage"
        />

        <BaseButton type="submit" variant="primary" class="reset-card__submit">
          Alterar senha
        </BaseButton>
      </form>

      <p class="reset-card__back">
        <router-link :to="{ name: 'Home' }">Cancelar</router-link>
      </p>
    </template>

    <template v-else>
      <h2 class="reset-card__title">Token inválido</h2>
      <p class="reset-card__sub">
        Não foi possível validar o token de recuperação de senha. Tente novamente mais tarde.
      </p>
      <p class="reset-card__back">
        <router-link :to="{ name: 'Home' }">Ir para o início</router-link>
      </p>
    </template>
  </div>
</template>

<script>
import { useField } from 'vee-validate';
import { onBeforeMount, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import loginService from '../../../../api/person/login';
import BaseButton from '../../../../components/ui/BaseButton.vue';
import InputField from '../../../../components/ui/InputField.vue';
import validators from '../../../../utils/validators';

export default {
  components: {
    BaseButton,
    InputField,
  },
  name: 'NewPasswordForm',
  props: {},
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();

    const TIMEOUT_TRY_AGAIN = 60;

    const { value: passwordValue, errorMessage: passwordErroMessage } = useField(
      'password',
      validators.validateEmptyRequired,
    );

    const { value: confirmPasswordValue, errorMessage: confirmPasswordErroMessage } = useField(
      'confirmPassword',
      validators.validateEmptyRequired,
    );

    const state = reactive({
      tokenValid: false,
      checked: false,
      time: TIMEOUT_TRY_AGAIN,
      enabledButton: false,
      token: {
        value: '',
      },
      password: {
        value: passwordValue,
        errorMessage: passwordErroMessage,
      },
      confirmPassword: {
        value: confirmPasswordValue,
        errorMessage: confirmPasswordErroMessage,
      },
    });

    onBeforeMount(async () => {
      const { code: token } = route.query;
      state.token.value = token;
      const { data } = await loginService.validateToken({ token });

      if (data) {
        const { statusCode } = data;

        if (statusCode === 200) {
          state.tokenValid = true;
          state.checked = true;
        }
      }
    });

    const redirectLogin = () => {
      router.push({ name: 'Login' });
    };

    async function handleChangePassword() {
      if (state.confirmPassword.value !== state.password.value) {
        toast.error('As senhas não combinam');

        return;
      }

      const { data, errors } = await loginService.changePassword({
        password: state.password.value,
        token: state.token.value,
      });

      if (errors) {
        toast.error(errors.statusText);
        return;
      }

      if (data) {
        toast.success(
          'Alteração de senha realizada com sucesso!',
        );

        router.push({ name: 'Login' });
      }
    }

    return {
      state,
      emit,
      handleChangePassword,
      redirectLogin,
    };
  },
};
</script>

<style scoped>
.reset-card {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: var(--gap-lg);
  background: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-lg);
  padding: 40px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);
}

.reset-card form {
  display: flex;
  flex-direction: column;
  gap: var(--gap-lg);
}

.reset-card__title {
  font-family: var(--font-brand);
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--white);
}

.reset-card__sub {
  font-family: var(--font-brand);
  font-size: 14px;
  color: var(--muted);
  margin-top: -8px;
}

.reset-card__validating {
  font-family: var(--font-brand);
  font-size: 14px;
  color: var(--muted);
  text-align: center;
}

.reset-card__submit {
  width: 100%;
}

.reset-card__back {
  text-align: center;
  font-family: var(--font-brand);
  font-size: 13px;
}

.reset-card__back a {
  color: var(--cyan);
  font-weight: 600;
  text-decoration: none;
}
</style>
